import { useState } from 'react'

import ReloadIcon from '@/assets/icons/icon-reload.svg'
import SadFaceIcon from '@/assets/icons/icon-sad-face.svg'

import { Button } from '../button'

export const PageFallback = () => {
  const [isReloading, setIsReloading] = useState(false)

  const handleClickTryAgain = () => {
    setIsReloading(true)
    window.location.reload()
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center bg-secondary-100 dark:bg-[#232634]">
      <div className="p-5 rounded-md flex flex-col items-center gap-4 max-w-[298px] bg-secondary-50 dark:bg-secondary-600">
        <div className="flex flex-col gap-2 text-secondary-300 text-center items-center">
          <SadFaceIcon />
          <h1 className="text-[28px] leading-[36px] font-medium">
            Oops, something went wrong.
          </h1>
          <p className="text-base leading-[26px]">
            An unexpected error occurred. Please try refreshing the page or
            contact support if the issue persists.
          </p>
        </div>
        <Button
          className="gap-1.5"
          variant="outline"
          onClick={handleClickTryAgain}
          disabled={isReloading}
        >
          <ReloadIcon className={isReloading ? 'animate-spin' : ''} />
          <span>Try again</span>
        </Button>
      </div>
    </div>
  )
}
